import { Dispatch, SetStateAction, useContext } from "react";
import React from "react";

export type ApiHelperAppContextValue = {
  isLoading: boolean;
  setIsLoading: (isLoading: boolean) => void;
};

export const ApiHelperAppContext =
  React.createContext<ApiHelperAppContextValue>(
    undefined as unknown as ApiHelperAppContextValue
  );

export const useApiHelperAppContext = (): ApiHelperAppContextValue => {
  const contextValue = useContext(ApiHelperAppContext);

  if (!contextValue) {
    throw new Error(
      "To use 'ApiHelperAppContextProvider' make sure that you wrap your component with <ApiHelperAppContextProvider>{{...}}</AppApiHelperAppContextProviderContextProvider>."
    );
  }

  return contextValue;
};
